import { gdiyEpisodeUrl } from "#/lib/gdiy";

type EpisodePlatformFields = {
  guest: string;
  applePodcastLink: string | null;
  youtubeLink: string | null;
  spotifyLink: string | null;
};

type PlatformLink = {
  label: string;
  href: string;
  className?: string;
};

export function getPrimaryEpisodeHref(episode: EpisodePlatformFields): string | null {
  return (
    gdiyEpisodeUrl(episode.guest) ||
    episode.applePodcastLink ||
    episode.spotifyLink ||
    episode.youtubeLink ||
    null
  );
}

function getEpisodePlatformLinks(episode: EpisodePlatformFields): Array<PlatformLink> {
  return [
    {
      label: "GDIY",
      href: gdiyEpisodeUrl(episode.guest) ?? "",
      className: "platform-pill--gdiy",
    },
    { label: "Apple", href: episode.applePodcastLink ?? "" },
    { label: "YouTube", href: episode.youtubeLink ?? "" },
    { label: "Spotify", href: episode.spotifyLink ?? "" },
  ].filter((link) => link.href);
}

export function EpisodePlatformLinks({
  episode,
  className,
}: {
  episode: EpisodePlatformFields;
  className: string;
}) {
  const links = getEpisodePlatformLinks(episode);
  if (links.length === 0) return null;

  return (
    <div className={`platform-links ${className}`} aria-label="Listen on">
      {links.map((link) => (
        <a
          key={link.label}
          className={link.className ? `platform-pill ${link.className}` : "platform-pill"}
          href={link.href}
          target="_blank"
          rel="noreferrer noopener"
        >
          {link.label}
        </a>
      ))}
    </div>
  );
}
